//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import themeMixin from 'kolibri.coreVue.mixins.themeMixin';
import KGrid from 'kolibri.coreVue.components.KGrid';
import KGridItem from 'kolibri.coreVue.components.KGridItem';
import ProgressIcon from 'kolibri.coreVue.components.ProgressIcon';
import ElapsedTime from 'kolibri.coreVue.components.ElapsedTime';
import { ContentNodeKinds } from 'kolibri.coreVue.vuex.constants';
import KLabeledIcon from 'kolibri.coreVue.components.KLabeledIcon';
import KIcon from 'kolibri.coreVue.components.KIcon';

export default {
  name: 'PageStatus',
  $trs: {
    title: '{name} - Quiz performance',
    overallScore: 'Overall score: { score, number, percent }',
    questionsCorrect: 'Questions correct: {correct, number} of {total, number}',
    completed: 'Completed',
    inProgress: 'In progress',
    notStarted: 'Not started',
  },
  components: {
    KGrid,
    KGridItem,
    ProgressIcon,
    ElapsedTime,
    KIcon,
    KLabeledIcon,
  },
  mixins: [themeMixin],
  props: {
    userName: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      default: () => [],
    },
    completed: {
      type: Boolean,
      default: false,
    },
    completionTimestamp: { type: Date },
    contentName: {
      type: String,
      required: true,
    },
  },
  computed: {
    questionsCorrect() {
      return this.questions.reduce((a, q) => a + (q.correct === 1 ? 1 : 0), 0);
    },
    score() {
      return this.questions.reduce((a, q) => a + q.correct, 0) / this.questions.length || 0;
    },
    progress() {
      // Either return in completed or in progress
      return this.completed ? 1 : 0.1;
    },
    kind() {
      return ContentNodeKinds.EXAM;
    },
  },
};

